import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Dot, { type DotProps } from "./Dot"

export type DotTextProps = ComponentProps<"span"> & {
  variant: DotProps["variant"]
  dotClassName?: DotProps["className"]
  dotStyle?: DotProps["style"]
}

function DotText(props: DotTextProps) {
  const { variant, className, children, dotClassName, dotStyle, ...spanProps } =
    props
  return (
    <span className={cn("dot-text", className)} {...spanProps}>
      <Dot variant={variant} className={dotClassName} style={dotStyle} />
      {children}
    </span>
  )
}

export default DotText
